import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50">俄罗斯妈妈</span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              走进真实的俄罗斯妈妈世界，探索跨文化育儿、家庭传统与生活智慧。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">文章分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">品牌故事</Link>
              </li>
              <li>
                <a href="/about#contact" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors cursor-pointer">联系我们</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-accent-500 hover:text-background-950 transition-colors cursor-pointer text-background-50/60">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-accent-500 hover:text-background-950 transition-colors cursor-pointer text-background-50/60">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 hover:bg-accent-500 hover:text-background-950 transition-colors cursor-pointer text-background-50/60">
                <i className="ri-chat-smile-2-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/40">
            &copy; {currentYear} 俄罗斯妈妈. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-sm text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}